export const isProductionEnvironment = () => {
  return window.location.host.includes("www.asos.com");
};
